import React, {Component} from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import {downloadCsv, operationCSVHeader} from '../../../utils/ExportCsvUtils'
import T from 'i18n-react';

import OperationTypeEnum from '../../../enums/OperationTypeEnum';
import CardType from '../../../enums/CardType';
import OPERATION_CATEGORY from '../../../enums/OperationCategoryEnum';
import LOCATION from '../../../enums/Location';
import STREAM_TYPE from '../../../enums/StreamType';
import OperationService from '../../../services/OperationService';

class ExportCsv extends Component {

    constructor(props) {
        super(props);
        this.dataList = [];
        this.headerList = [];
        this.filename = '';

        this.formatData(props.operationList, props.selectedCountry, props.client, props.bu);
        this.headerList = operationCSVHeader(props.operationList, props.selectedCountry);
        this.setCorrectFilename(props.fundingDate);
    }

    /**
     * Quand on récupère de nouvelle props on refait l'appel WS
     * @param {*} newProps
     */
    componentWillReceiveProps(newProps) {
        if(!newProps.operationList || !newProps.operationList.length) {
            return;
        }
        // On clean avant de regenerer les valeurs
        this.cleanData();
        this.formatData(newProps.operationList, newProps.selectedCountry, newProps.client, newProps.bu);
        this.headerList = operationCSVHeader(newProps.operationList, newProps.selectedCountry);
        this.setCorrectFilename(newProps.fundingDate)
    }

    formatAmount(amount) {
        return (amount / 100).toFixed(2).replace('.', ',');
    }

    /**
     * Crée le contenu du fichier csv
     * @param operationList
     * @param country
     * @param client
     * @param bu
     */
    formatData(operationList, country, client, bu) {
        let isCoda = false;
        if(operationList[0].cardType) {
            isCoda = true;
        }

        if(country === LOCATION.FR) {
            operationList.forEach((item) => {
                this.dataList.push(
                    [
                        '"' + (item.fundingDate ? item.fundingDate :  (this.props.fundingDate && this.props.fundingDate.indexOf('from') === -1 ? this.props.fundingDate : T.translate('table.allDates'))) + '"',
                        '"' + (item.streamType === STREAM_TYPE.PASS_CARD.code ? item.shopPass : item.contractNumber) + '"',
                        '"' + (client ? client.name : '') + '"',
                        '"' + (bu ? bu.name : '') + '"',
                        '"' + item.nameShop + '"',
                        '"' + (item.tradeDate ? item.tradeDate : T.translate('table.allDates')) + '"',
                        '"' + OperationService.getDataActivity(item).text + '"',
                        '"' + ((item.category && item.category === OPERATION_CATEGORY.PROCESSING_FEES)
                            || item.nbTransactions == null ?
                                ''
                                :
                                item.nbTransactions.toString()
                        ) + '"',
                        '"' + (item.category && item.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                T.translate('table.processingFees')
                                :
                                item.sens > 0 ? T.translate('table.debit') : T.translate('table.credit')
                        ) + '"',
                        '"' + (item.category && item.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                0
                                :
                                this.formatAmount(item.grossAmount)
                        ) + '"',
                        '"' + this.formatAmount(item.netAmount - item.grossAmount) + '"',
                        '"' + this.formatAmount(item.netAmount) + '"'
                    ]
                );
            })
        } else {
            operationList.forEach((item) => {
                this.dataList.push(
                    [
                        '"' + (item.fundingDate ? item.fundingDate :  (this.props.fundingDate && this.props.fundingDate.indexOf('from') === -1 ? this.props.fundingDate : T.translate('table.allDates'))) + '"',
                        '"' + (item.streamType === STREAM_TYPE.PASS_CARD.code ? item.shopPass : item.contractNumber) + '"',
                        '"' + client.name + '"',
                        '"' + bu.name + '"',
                        '"' + item.nameShop + '"',
                        '"' + (item.tradeDate ? item.tradeDate : T.translate('table.allDates')) + '"',
                        '"' + (isCoda ? T.translate(CardType[item.cardType].name) : (item.operationType && item.sens ? OperationTypeEnum[item.operationType.toString() + item.sens.toString()] : "")) + '"',
                        '"' + (item.category && item.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                T.translate('table.processingFees')
                                :
                                item.sens > 0 ? T.translate('table.debit') : T.translate('table.credit')
                        ) + '"',
                        '"' + (item.category && item.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                0
                                :
                                this.formatAmount(item.grossAmount)
                        ) + '"',
                        '"' + this.formatAmount(item.netAmount - item.grossAmount) + '"',
                        '"' + this.formatAmount(item.netAmount) + '"'
                    ]
                );
            })
        }
    }

    /**
     * Utilisé pour supprimer les anciennes valeurs
     */
    cleanData() {
        this.dataList = [];
        this.headerList = [];
    }

    // Format fichier operation_jj-mm-aaaa.csv
    setCorrectFilename(fundingDate) {
        if(!fundingDate) {
            return
        }
        this.filename = 'operation_' + fundingDate + '.csv';
    }

    render() {
        return(
            <RaisedButton className="footerButton" label="CSV" secondary onClick={() => {downloadCsv(this.dataList, this.headerList, this.filename)}}/>
        )
    }
}

export default ExportCsv;



// WEBPACK FOOTER //
// ./src/components/tableComponent/export/ExportCsv.js